import { differenceInDays } from "date-fns";
import { IArchiveLineItemToRecycle, ILineitem } from "model/lineitems";

//⚠️
export const NO_DEFAULT_CAMPAIGN_ID_AVAILABLE =
  "SKAdNetwork line item limit exceeded. This line item will not be tracked by SKAdNetwork. Re-use an older line item if SKAdNetwork tracking is needed. ";

export const LINEITEM_ARCHIVED_LESS_THAN_A_WEEK_AGO = (
  oldName: string,
  newName: string,
  days: string | number = "unknown amount of"
) => (
  <span>
    Archived line item <b>{oldName}</b> was still running up until{" "}
    <b>{days} days ago</b>. Depending on the advertiser app's configuration,
    this may result in some conversions from <b>{oldName}</b> being assigned to{" "}
    <b>{newName}</b>.{" "}
  </span>
);
export const DEFAULT_CAMPAIGN_ID_REUSED = (oldName) => (
  <span>
    SKAdNetwork line item limit exceeded. An ID has been re-used from archived
    line item <b>{oldName}</b>.
  </span>
);

export const getSkadTrackingWarning = (
  availableId?: number | string,
  reusedItem?: IArchiveLineItemToRecycle,
  newItem?
) => {
  if (availableId && reusedItem) {
    const daysSinceArchiving =
      reusedItem.archivedDate &&
      //eslint-disable-next-line @miovision/disallow-date/no-new-date
      differenceInDays(reusedItem.archivedDate, new Date());

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        {DEFAULT_CAMPAIGN_ID_REUSED(reusedItem.name)}
        {LINEITEM_ARCHIVED_LESS_THAN_A_WEEK_AGO(
          reusedItem.name,
          newItem.name,
          daysSinceArchiving
        )}
      </div>
    );
  }

  if (!availableId) {
    return NO_DEFAULT_CAMPAIGN_ID_AVAILABLE;
  }
  return null;
};

export const recycleSkanLineitem = (recycledLi: ILineitem) => {
  // NOTE: object needs to be removed entirely
  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { skAdNetworkConfiguration, ...liWithoutSkAd } = recycledLi;
  return liWithoutSkAd;
};
